import '../assets/css/style.css';
import Sidebar from "./Sidebar";
import TutorialsBody from "./TutorialsBody";
import TopNavbar from './TopNavbar';
import Footer from './Footer';
import { HelmetProvider } from "react-helmet-async";


const Tutorials = () => {
    return (
        <>
        <TopNavbar/>
        <div className="row g-0" style={{padding: '0 20px'}}>

            <div className="col-xl-3 col-lg-3 col-md-2 col-sm-1">
                {/* for space */}
            </div>

            <div className="col-xl-6 col-lg-6 col-md-8 col-sm-10" id="tutorials-body">
                <HelmetProvider>
                    <TutorialsBody/>
                </HelmetProvider>
            </div>
            
            <div className="col-xl-3 col-lg-3 col-md-2 col-sm-1">
                {/* for space */}
            </div>

        </div> 
        <Footer/>
        </>
    )
}

export default Tutorials;